import MainPlugins from "./main/PluginSetup.js";
import AccountPlugins from "./account/PluginSetup.js";
import SettingsPlugins from "./settings/PluginSetup.js";
import GroupScreenPlugins from "./group/PluginSetup.js";
import ItemInfoScreenPlugins from "./itemInfo/PluginSetup.js";
const install = molten => {
  MainPlugins.install(molten);
  AccountPlugins.install(molten);
  SettingsPlugins.install(molten);
  GroupScreenPlugins.install(molten);
  ItemInfoScreenPlugins.install(molten);
};
export default {
  install
};